import React, { useEffect } from "react";
import styled from "styled-components";
import { Control, useForm } from "react-hook-form";
import InputField from "components/UI/InputField/InputField";
import UnitTypeSelect from "components/common/dl_unit/UnitTypeSelect/UnitTypeSelect";
import SubmitResetNav from "components/common/form/SubmitResetNav";
import FormFieldContainer from "components/layout/style/form/FormFieldContainer";
import UnitFormFieldSection from "./UnitFormFieldSection/UnitFormFieldSection";

export type UnitFormState = {
  uType: string;
  slug: string;
  num: string;
  fVals: Record<string, string>;
};

type UnitFormProps = {
  control: Control<UnitFormState>;
  errorText?: string;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onReset: () => void;
};

const UnitForm = ({
  control,
  errorText = "",
  onSubmit,
  onReset,
}: UnitFormProps) => {
  const { setFocus } = useForm();

  useEffect(() => {
    // window.scrollTo(0, 0);
    setFocus("slug");
  }, [setFocus]);

  return (
    <DivForm>
      <form onSubmit={onSubmit}>
        <SubmitResetNav onReset={onReset} />

        <FormFieldContainer>
          <InputField
            name="slug"
            control={control}
            label="Slug"
            id="slug"
            autoFocus={true}
          />
        </FormFieldContainer>
        <FormFieldContainer>
          <UnitTypeSelect control={control} />
        </FormFieldContainer>
        <FormFieldContainer>
          <InputField
            name="num"
            control={control}
            label="Broj"
            id="num"
            type="number"
          />
        </FormFieldContainer>
        <UnitFormFieldSection control={control} />

        {errorText !== "" && <ErrorText>{errorText}</ErrorText>}

        <DivNav>
          <SubmitResetNav onReset={onReset} />
        </DivNav>
      </form>
    </DivForm>
  );
};

export default UnitForm;

const DivForm = styled.div`
  width: 100%;
`;

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  color: #b00020;
  font-weight: 600;
`;
